module.exports = new __parcel__URL__("integration.4d030b1d.svg").toString();